import styled from 'styled-components'

import { Card } from '@/components/ui/card'

export const Container = styled(Card)(({ theme }) => ({
  flex: 'none',
  gap: theme.space['24'],
  height: 'auto',
}))

export const InfoGrid = styled.div(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.space['20'],
  justifyContent: 'space-between',
}))

export const InfoField = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  gap: theme.space['8'],
}))

export const InfoFieldText = styled.div(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const QuestionsSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['4'],
}))
